const PRODUCT_ATTRIBUTE_TYPES = Object.freeze([
    { value: 'product_name', label: 'Product name' },
    { value: 'product_description', label: 'Product description' },
    { value: 'catalogue_name', label: 'Catalogue name' },
    { value: 'model', label: 'Model' },
    { value: 'brand', label: 'Brand' },
    { value: 'product_id', label: 'Product ID' },
    { value: 'supplier_product_id', label: 'Supplier product ID' },
    { value: 'ean', label: 'EAN' },
    { value: 'scip_number', label: 'SCIP number' },
    { value: 'scip_name', label: 'SCIP name' },
    { value: 'supplier_scip_number', label: 'Supplier SCIP number' },
    { value: 'part_number', label: 'Part number' },
    { value: 'catalogue_number', label: 'Catalogue number' },
    { value: 'gtin', label: 'GTIN' },
    { value: 'gpc', label: 'GPC' },
    { value: 'jan', label: 'JAN' },
    { value: 'reference_number', label: 'Reference number' },
    { value: 'uuid', label: 'UUID' },
    { value: 'dds_reference_number', label: 'DDS reference number' },
    { value: 'dds_verification_number', label: 'DDS verification number' },
    { value: 'other', label: 'Other' },
])

const PRODUCT_ATTRIBUTE_TYPE_VALUES = Object.freeze(
    PRODUCT_ATTRIBUTE_TYPES.map(option => option.value),
)

const PRODUCT_TITLE_ATTRIBUTE_PRIORITY = Object.freeze([
    'product_name',
    'model',
    'product_id',
    'supplier_product_id',
])

const isNonEmpty = value => typeof value === 'string' && value.trim().length > 0

const productAttributes = product => (
    product && Array.isArray(product.attributes) ? product.attributes : []
)

const firstProductAttribute = (product, type) => productAttributes(product)
    .find(attribute => attribute && attribute.type === type && isNonEmpty(attribute.value)) || null

const productAttributeTypeLabel = type => {
    const option = PRODUCT_ATTRIBUTE_TYPES.find(item => item.value === type)
    if (option) {
        return option.label
    }
    return type ? `Unsupported attribute type: ${type}` : 'Unsupported attribute type'
}

const productDisplayName = product => {
    const attribute = PRODUCT_TITLE_ATTRIBUTE_PRIORITY
        .map(type => firstProductAttribute(product, type))
        .find(Boolean)
    return attribute ? attribute.value : ''
}

const legacyProductAttributes = product => [
    { type: 'product_name', value: product && product.name, evidence: null },
    { type: 'product_id', value: product && product.code, evidence: null },
    { type: 'scip_number', value: product && product.scipNumber, evidence: null },
].filter(attribute => isNonEmpty(attribute.value))

const normalizeReviewProduct = product => {
    const source = product && typeof product === 'object' ? product : {}
    const {
        name,
        code,
        scipNumber,
        ...rest
    } = source
    const attributes = productAttributes(source).length
        ? productAttributes(source)
        : legacyProductAttributes(source)

    return {
        ...rest,
        attributes: attributes.map(attribute => ({
            ...(attribute && typeof attribute === 'object' ? attribute : {}),
            evidence: attribute && typeof attribute.evidence !== 'undefined'
                ? attribute.evidence
                : null,
        })),
    }
}

const serializeReviewProduct = product => {
    const normalized = normalizeReviewProduct(product)
    return {
        ...normalized,
        attributes: normalized.attributes.map(attribute => ({
            type: attribute.type,
            value: attribute.value,
            evidence: typeof attribute.evidence === 'undefined' ? null : attribute.evidence,
        })),
    }
}

export {
    firstProductAttribute,
    isNonEmpty,
    normalizeReviewProduct,
    PRODUCT_ATTRIBUTE_TYPES,
    PRODUCT_ATTRIBUTE_TYPE_VALUES,
    productAttributeTypeLabel,
    productAttributes,
    productDisplayName,
    serializeReviewProduct,
}
